var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 11,
  fill: "none",
  viewBox: "0 0 18 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#330DF2",
  fillRule: "evenodd",
  d: "m13.287.304 4.713 5-4.713 5-1.486-1.482 2.312-2.453H0v-2.13h14.113l-2.312-2.453z",
  clipRule: "evenodd"
})));
export default SvgArrowinline;